export type BoschUiPageEvent = {
  totalElements: number;
  pageNumber: number;
  pageSize: number;
  previousPageNumber: number;
};

export type BoschUiPaginatorConfigType = {
  totalPages: number;
  pages: Array<string | number>;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
} & BoschUiPageEvent;
